export default __webpack_public_path__ + "static/media/ALLERGEN_PEANUTS.645aa1b2.png";